var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoriesdesignShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 74,
    viewBox: "0 0 102 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 58.913C38.4554 55.9199 57.8372 57.5949 76.5215 64.0435C82.9617 66.2662 89.6132 68.3421 95.7824 71.2609C97.3608 72.0076 98.6209 73 100.391 73",
    stroke: "#244034",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82593 49.5217C12.8542 36.9892 11.6757 20.3885 6.47811 8.26086C5.23061 5.35004 3.19467 3.19481 0.999848 0.999989",
    stroke: "#244034",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1303 44.8261C27.4681 39.4883 32.5623 34.1318 39.3477 30.7391",
    stroke: "#244034",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriesdesignShape);
export default __webpack_public_path__ + "static/media/categoriesdesignShape.ec3decf1d4488e8c3b0b954345181716.svg";
export { ForwardRef as ReactComponent };